export default __webpack_public_path__ + "static/media/SolverEDGE.b76f3a9f.svg";